import React from "react";
import CustomerInformationSummary from "../components/customer-information-summary";
import OrderSummary from "../components/order-summary";
import { getRetailerInformation } from "../utils/retailer";
import shouldUseCreditAssessment from "../utils/credit-assessment/usage-resolver";
export default (props) => {
    React.useEffect(() => {
        const usingCreditAssessment = shouldUseCreditAssessment(props.data, props.orderOptions);
        const shouldAcceptCase = usingCreditAssessment && !props.creditAssessmentStatus.isAccepted();
        if (shouldAcceptCase) {
            props.acceptCreditAssessmentCase();
        }
    }, []);
    const retailerInformation = getRetailerInformation(props.orderOptions);
    const { name, email, phoneNumber } = retailerInformation;
    return (React.createElement("div", { "data-ecom-page": "" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Tack f\u00F6r din order!"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null,
                    "En orderbekr\u00E4ftelse kommer att skickas till din e-postadress",
                    " ",
                    React.createElement("span", { className: "font-medium" }, props.data.customer.email),
                    ".* ",
                    name,
                    " tar kontakt med dig f\u00F6r att g\u00E5 igenom avtal, betalning och leverans. Sedan \u00E4r det klart! K\u00F6r f\u00F6rsiktigt ute p\u00E5 v\u00E4garna."),
                React.createElement("p", { className: "font-size-small text-dark-lighten" }, "*Orderbekr\u00E4ftelsen skickas normalt inom 10 minuter, men kan i undantagsfall dr\u00F6ja upp till 48 timmar."))),
        React.createElement("section", { className: "page-section page-section-accent" },
            React.createElement("div", { className: "page-section-accent-content" },
                React.createElement("h2", { className: "h6" }, "Din order")),
            React.createElement(OrderSummary, Object.assign({}, props))),
        React.createElement("section", { className: "page-section" },
            React.createElement("h2", { className: "h6" }, "Kunduppgifter"),
            React.createElement(CustomerInformationSummary, Object.assign({}, props))),
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Har du fr\u00E5gor?"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null,
                    name && (React.createElement(React.Fragment, null,
                        "Kontakta ",
                        name)),
                    email && (React.createElement(React.Fragment, null,
                        " ",
                        "- ",
                        React.createElement("a", { href: `mailto:${email}` }, email))),
                    phoneNumber && (React.createElement(React.Fragment, null,
                        " ",
                        "-",
                        " ",
                        React.createElement("a", { href: `tel:${phoneNumber}` }, phoneNumber)))))),
        React.createElement("section", { className: "page-section page-section-bottom" },
            React.createElement("button", { "data-ecom-button": "full-width", onClick: props.onExit }, "St\u00E4ng"))));
};
